module.exports = __webpack_public_path__ + "static/img/female-bg-fr.3643a2f8.png";